import { render, staticRenderFns } from "./QualificationRequirement.vue?vue&type=template&id=a65de0c0&scoped=true"
import script from "./QualificationRequirement.vue?vue&type=script&lang=ts"
export * from "./QualificationRequirement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a65de0c0",
  null
  
)

export default component.exports